export default "__VITE_ASSET__oKNiY0H3__"